"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTemplatesOnPlatform = exports.getAllTemplatesOnPlatform = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const customEngineAgent_1 = require("./customEngineAgent");
const da_1 = require("./da");
const graphConnector_1 = require("./graphConnector");
const me_1 = require("./me");
const special_1 = require("./special");
const teams_1 = require("./teams");
const vs_1 = require("./vs");
const wxp_1 = require("./wxp");
const allTemplates = [
    ...da_1.declarativeAgentTemplates,
    ...customEngineAgent_1.customEngineAgentTemplates,
    ...teams_1.teamsAgentsAndAppsTemplates,
    ...me_1.messagingExtensionTemplates,
    ...special_1.specialTemplates,
    ...vs_1.vsOnlyTemplates,
    ...wxp_1.wxpTemplates,
    ...graphConnector_1.graphConnectorTemplates,
];
const defaultGeneratorTemplates = [
    ...customEngineAgent_1.customEngineAgentTemplates,
    ...teams_1.teamsAgentsAndAppsTemplates,
    ...me_1.messagingExtensionTemplates,
    ...vs_1.vsOnlyTemplates,
    ...graphConnector_1.graphConnectorTemplates,
];
// used by programming language question options filter
function getAllTemplatesOnPlatform(platform) {
    switch (platform) {
        case teamsfx_api_1.Platform.VSCode:
            return allTemplates.filter((t) => t.language !== "csharp");
        case teamsfx_api_1.Platform.VS:
            return allTemplates.filter((t) => t.language === "csharp");
        case teamsfx_api_1.Platform.CLI:
            return allTemplates;
        default:
            return [];
    }
}
exports.getAllTemplatesOnPlatform = getAllTemplatesOnPlatform;
// used by default generator
function getDefaultTemplatesOnPlatform(platform) {
    switch (platform) {
        case teamsfx_api_1.Platform.VSCode:
            return defaultGeneratorTemplates.filter((t) => t.language !== "csharp");
        case teamsfx_api_1.Platform.VS:
            return defaultGeneratorTemplates.filter((t) => t.language === "csharp");
        case teamsfx_api_1.Platform.CLI:
            return defaultGeneratorTemplates;
        default:
            return [];
    }
}
exports.getDefaultTemplatesOnPlatform = getDefaultTemplatesOnPlatform;
//# sourceMappingURL=index.js.map